import React, { useState } from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { icons } from './ui/Icons';

/**
 * Modal para criar avaliação após serviço concluído
 */
const ReviewModal = ({ isOpen, onClose, barbershopName, appointmentId, onSubmit }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (rating === 0) {
      alert('Por favor, selecione uma avaliação de 1 a 5 estrelas');
      return;
    }

    onSubmit({
      rating,
      comment: comment.trim(),
      appointmentId
    });

    handleClose();
  };

  const handleClose = () => {
    setRating(0);
    setHoveredRating(0);
    setComment('');
    onClose();
  };

  const renderStars = () => {
    return [1, 2, 3, 4, 5].map((star) => {
      const isFilled = star <= (hoveredRating || rating);
      
      return (
        <button
          key={star}
          type="button"
          onClick={() => setRating(star)}
          onMouseEnter={() => setHoveredRating(star)}
          onMouseLeave={() => setHoveredRating(0)}
          className="transition-transform hover:scale-110"
        >
          {icons.star({
            className: `h-10 w-10 ${
              isFilled ? 'text-yellow-400 fill-current' : 'text-gray-300'
            }`
          })}
        </button>
      );
    });
  };

  const ratingLabels = {
    1: 'Péssimo',
    2: 'Ruim',
    3: 'Regular',
    4: 'Bom',
    5: 'Excelente'
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Avaliar Atendimento">
      <form onSubmit={handleSubmit} className="space-y-6">
        
        {/* Nome da Barbearia */}
        <div className="text-center">
          <p className="text-gray-600 mb-1">Como foi sua experiência na</p>
          <h3 className="text-xl font-bold text-gray-900">{barbershopName}</h3>
        </div>

        {/* Estrelas */}
        <div className="flex flex-col items-center space-y-3">
          <label className="block text-sm font-medium text-gray-700">
            Sua avaliação
          </label>
          <div className="flex space-x-2">
            {renderStars()}
          </div>
          {rating > 0 && (
            <p className="text-sm font-semibold text-indigo-600">
              {ratingLabels[rating]}
            </p>
          )}
        </div>

        {/* Comentário */}
        <div>
          <label htmlFor="comment" className="block text-sm font-medium text-gray-700 mb-2">
            Comentário (opcional)
          </label>
          <textarea
            id="comment"
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Conte-nos sobre sua experiência..."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
            maxLength={500}
          />
          <p className="text-xs text-gray-500 mt-1 text-right">
            {comment.length}/500 caracteres
          </p>
        </div>

        {/* Botões */}
        <div className="flex justify-end space-x-3">
          <Button type="button" variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary">
            {icons.check({ className: 'h-5 w-5 mr-2' })}
            Enviar Avaliação
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ReviewModal;
